import { render, staticRenderFns } from "./BreadcrumbStructuredData.vue?vue&type=template&id=2c6fd314"
import script from "./BreadcrumbStructuredData.vue?vue&type=script&lang=js"
export * from "./BreadcrumbStructuredData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports